import React, { useContext, useState, useEffect, useRef } from 'react'
import * as Yup from 'yup'
import CustomCommonContext from '@/custom/context/common/commonContext'
import ProductCommonContext from '@/product/context/product/productContext'
import AuthContext from '@/product/context/auth/authContext'
import { useFormik } from 'formik'
import {
    mapData,
    dateFormatFunction,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import BaseActionPage from '@/custom/components/organisms/Product/BaseActionPages'
import UserContext from '@/product/context/user/userContext'
import ProductContext from '@/product/context/userProduct/productContext'
import '../../product/components/organisms/Customized/User/Tabs/Tabs.css'
import '../../product/components/organisms/Customized/User/Role/Role.css'

import { Button, Menu, MenuItem } from '@mui/material'
import CustomDialog from '@/product/components/organisms/Dialog'
import ReportContext from '@/product/context/report/reportContext'
import { useHistory } from 'react-router-dom'
import Loaders from '@/product/components/molecules/Loaders'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
// import Layout from '../../components/templates/Layout'
import Layout from '../../product/components/templates/Layout'

const AddUserForm = (props) => {
    const userContext = useContext(UserContext)
    const history = useHistory()
    const dynamicContext = useContext(DynamicContext)

    const { user_dynamicfields } = dynamicContext
    const [fieldValue, setFieldValue] = useState([])
    const {
        single_user,
        getSingleUser,
        userAction,
        responseStatus: responseStatusUser,
    } = userContext
    const data = props.data
    const toggleFullScreenPopup = props.function
    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const [buttonData, setButtonData] = useState([])

    const [mapDataValue, setMapDataValue] = useState([])
    const [formikValues, setFormikValues] = useState({})

    const mapDataValueRef = useRef(mapDataValue)
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    const handleMapDataValue = (childMapDataValue) => {
        setMapDataValue(childMapDataValue)
    }

    const [customValidation, setCustomValidation] = useState([])
    const [customInitialValues, setCustomInitialValues] = useState([])

    useEffect(() => {
        let customValidationTemp = {}
        let customInitial = { ...props.customInitial, probation: 1 }

        customValidationTemp = {
            ...props.customValidation,
            email: Yup.string()
                .email('Invalid email format')
                .max(250, 'Maximum 250 characters')
                .required('Required'),
            confirm_email:
                data?.status === 'new'
                    ? Yup.string()
                          .email('Invalid email format')
                          .oneOf([Yup.ref('email')], "Email's not match")
                          .required('Required!')
                    : Yup.string(),
            phone: Yup.string()
                .trim()
                .matches(/^[0-9- +()]*$/g, 'Only Numbers Are Allowed')
                .required('Required'),
            zip: Yup.string()
                .trim()
                .matches(
                    /^[A-Za-z0-9 ]*$/,
                    'Only letters, numbers, and spaces allowed'
                )
                .min(2, 'Minimum 2 characters')
                .max(7, 'Maximum 7 characters')
                .required('Required!'),
            state: Yup.string().required('Required!'),
            password: Yup.string()
                .matches(
                    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).*$/,
                    'Password must include uppercase and lowercase letters, a number, and a special character.'
                )
                .min(8, 'Minimum 8 characters')
                .required('Required'),

            confirm_password: Yup.string()
                .oneOf([Yup.ref('password')], 'Password does not match')
                .required('Required'),
            address1: Yup.string()
                .max(49, 'Maximum 50 characters')
                .required('Required'),
            // birth_date: Yup.string()
            //     .required('You must be more than 18 years old')
            //     .test(
            //         'is-18',
            //         'You must be more than 18 years old',
            //         function (value) {
            //             if (!value) return false

            //             const [day, month, year] = value.split('-')
            //             const formattedDate = new Date(
            //                 `${month}-${day}-${year}`
            //             ) // Format as MM-DD-YYYY

            //             const today = new Date()
            //             const eighteenYearsAgo = new Date(
            //                 today.getFullYear() - 18,
            //                 today.getMonth(),
            //                 today.getDate()
            //             )

            //             return formattedDate <= eighteenYearsAgo
            //         }
            //     ),
        }
        setCustomInitialValues(customInitial)
        setCustomValidation(customValidationTemp)
    }, [props.fieldValue, props.customValidation, props.customInitial])

    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.from === 'userAction') {
                if (responseStatusUser?.status === 'success') {
                    if (props.function) {
                        props.function(false)
                    }
                }
                setIsLoading(false)
            }
        }
    }, [responseStatusUser])

    const additionalFormikUpdate = (data) => {
        if (props.additionalFormikUpdate) {
            props.additionalFormikUpdate(data)
        }
        setFormikValues(data)
    }

    const submitFunction = () => {
        const value = formikValues
        setIsLoading(true)

        if (value.approved_seller == 343) {
            value.seller_status = 'active'
        } else if (value.approved_seller == 344) {
            value.seller_status = 'unverified'
        }

        userAction(value)
    }
    const formSubmit = (value, data) => {
        setFormikValues({
            ...formikValues,
            market_status: data,
        })
        submitFunction()
    }

    const cancelSubmit = () => {
        setIsLoading(false)
    }

    useEffect(() => {
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
        if (data?.status === 'new') {
            setFormikValues({
                ...formikValues,
                id: 0,
            })
        }
    }, [data])

    useEffect(() => {
        const buttonDataTemp = []
        if (formikValues.id) {
            if (formikValues.market_status === 'draft') {
                buttonDataTemp.push({
                    type: 'button',
                    style: 'secondary',
                    label: 'Save as Draft',
                    additionalValue: 'draft',
                })
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'Submit',
                    additionalValue: 'open',
                })
            }
            if (formikValues.market_status === '') {
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'Update',
                    additionalValue: 'open',
                })
            } else {
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'Update',
                    additionalValue: 'open',
                })
            }
        } else {
            buttonDataTemp.push({
                type: 'submit',
                style: 'primary',
                label: 'Submit',
                additionalValue: 'open',
            })
        }
        setButtonData(buttonDataTemp)
    }, [formikValues.id, formikValues.market_status])

    useEffect(() => {
        if (user_dynamicfields && user_dynamicfields.length) {
            let dynamicValueAssign = []
            user_dynamicfields.forEach((item) => {
                // Update the content if name is 'misc_password'
                if (item.name === 'misc_password') {
                    item.content = 'Password and Membership Details'
                }
                if (item.name === 'approved_seller') {
                    item.initialDefault = 343
                }
                if (item.name === 'retailer') {
                    item.initialDefault = 345
                }
                if (item.name === 'multibox_lisiting') {
                    item.initialDefault = 347
                }
                if (item.name === 'partialbox_listing') {
                    item.initialDefault = 349
                }
                // Check if item should be added to dynamicValueAssign
                if (item.view_on) {
                    if (item.view_on.includes('3')) {
                        dynamicValueAssign.push(item)
                    }
                } else {
                    // If item.view_on is undefined or falsy, push to dynamicValueAssign
                    dynamicValueAssign.push(item)
                }
            })
            dynamicValueAssign.push({
                name: 'market_status',
                value: 'draft',
                type: 'default',
                active: 1,
            })
            const temp = dynamicValueAssign.filter((item) => {
                return (
                    // item.name != 'password' &&
                    // item.name != 'confirm_password' &&
                    item.name != 'companyname' &&
                    item.name != 'phone' &&
                    item.name != 'reenter_email_address' &&
                    item.name != 'user_restrict' &&
                    item.name != 'seller_restrict' &&
                    item.name !== 'search_default' &&
                    item.for_buyer === 1
                )
            })
            setFieldValue(temp)
        }
    }, [user_dynamicfields])

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }

    return (
        <Layout>
            {isLoading ? (
                <Loaders isLoading={isLoading} />
            ) : (
                <BaseActionPage
                    arrayValue={fieldValue}
                    populateValidation={props.populateValidation}
                    data={props.data}
                    additionalFormikUpdate={additionalFormikUpdate}
                    editFunction={getSingleUser}
                    editValue={single_user}
                    handleMapDataValue={handleMapDataValue}
                    actionFunction={formSubmit}
                    cancelFunction={cancelSubmit}
                    buttonAction={buttonData}
                    customValidation={customValidation}
                    customInitialValues={customInitialValues}
                />
            )}
        </Layout>
    )
}

export default AddUserForm
